import Vue, { getCurrentInstance } from 'vue';
import VueRouter from 'vue-router';
import Player from '@/views/Player.vue';
import RegisterCode from '@/views/RegisterCode.vue';
import NoLayout from '@/views/NoLayout.vue';
import PageNotFound from '@/views/PageNotFound.vue';
import { isLoggedIn } from '@/services/auth';
import { SCREEN_LAYOUT_ENUM, SCREEN_ID_ENUM, SESSION_TOKEN_ENUM } from '@/constants';
import { clearStorage, prepareAndSendOfflineMessage } from '@/helpers/utils';

Vue.use(VueRouter);

const ifNotAuthenticated = async (to, from, next) => {
  if (!isLoggedIn()) {
    next('/');
    return;
  }
  if (!localStorage.getItem(SCREEN_ID_ENUM)) {
    await prepareAndSendOfflineMessage();
    await clearStorage();
    next('/');
    return;
  }
  next();
};

const ifAuthenticated = (to, from, next) => {
  // OLD CODE - KEEPING FOR REFERENCE

  // if (isLoggedIn() && localStorage.getItem(SCREEN_LAYOUT_ENUM)) {
  //   next(`/player/${localStorage.getItem(SCREEN_LAYOUT_ENUM)}`);
  //   return;
  // } else if (isLoggedIn()) {
  //   next(`/no-layout`);
  //   return;
  // }
  // next();

  // NEW CODE - WITH EXPLANATION FROM AI
  /* 
    ## The Race Condition Scenario:
    **Scenario**: There's a brief moment where:
    - has cleared `SCREEN_LAYOUT_ENUM` but  might still be in memory/cache
    - OR  returns `true` due to some caching/timing issue
    - The router guard runs and sees:  but 
    - This triggers the second condition: `else if (isLoggedIn())` → `next('/no-layout')` ## Why This Happens Intermittently:

    1. **Browser timing variations**: Different browsers/devices have different timing for when  takes effect vs when router guards execute
    2. **JavaScript event loop timing**: The order of execution can vary based on system load
    3. **Vue router lifecycle**: The navigation guards might execute before the storage clearing has fully propagated ## Solutions:
  */
  const hasSessionToken = !!localStorage.getItem(SESSION_TOKEN_ENUM);
  const hasScreenId = !!localStorage.getItem(SCREEN_ID_ENUM);
  const hasScreenLayout = !!localStorage.getItem(SCREEN_LAYOUT_ENUM);

  if (!hasSessionToken || !hasScreenId) {
    next();
    return;
  }

  if (hasScreenLayout) {
    next(`/player/${localStorage.getItem(SCREEN_LAYOUT_ENUM)}`);
    return;
  } else {
    next(`/no-layout`);
    return;
  }
};

var app_title = 'PicFlow';

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: RegisterCode,
      beforeEnter: ifAuthenticated,
      meta: {
        title: () => {
          return `${app_title}`;
        },
        layout: 'empty',
      },
    },
    {
      path: '/no-layout',
      component: NoLayout,
      beforeEnter: ifNotAuthenticated,
      meta: {
        title: () => {
          return `${app_title}`;
        },
        layout: 'empty',
      },
    },
    {
      path: '/player/:layout_id',
      component: Player,
      beforeEnter: ifNotAuthenticated,
      meta: {
        title: () => {
          return `${app_title}`;
        },
        layout: 'empty',
      },
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        title: () => {
          return `${app_title}`;
        },
        layout: 'empty',
      },
    },
  ],
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title(to);
  });
});

export default router;

export function useRouter() {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');
  return vm.proxy.$root.$router;
}
